import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper, CheckboxFieldWrapper } from '../../Components/Fields';
import { doLoad } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import TableBody from '@material-ui/core/TableBody';

const ENDPOINT = "umlaufplan"

export const Fields = ({classes, handleChange, eintraege, paket, kuerzel, name, mo, di, mi, don, fr, sa, so, feiertage, ferien}) => (
    <Grid container spacing={8}>

        <TextFieldHelper disabled={true} n={2} value={paket} label="Paket" />
        <TextFieldHelper disabled={true} n={2} value={kuerzel} label="Kürzel" />
        <TextFieldHelper disabled={true} n={8} value={name} label="Name" />
                    
        <Grid item xs={12}><Divider /></Grid>

        <CheckboxFieldWrapper down disabled={true} n={1} name="Mo" checked={mo} />
        <CheckboxFieldWrapper down disabled={true} n={1} name="Di" checked={di} />
        <CheckboxFieldWrapper down disabled={true} n={1} name="Mi" checked={mi} />
        <CheckboxFieldWrapper down disabled={true} n={1} name="Do" checked={don} />
        <CheckboxFieldWrapper down disabled={true} n={1} name="Fr" checked={fr} />
        <CheckboxFieldWrapper down disabled={true} n={1} name="Sa" checked={sa} />
        <CheckboxFieldWrapper down disabled={true} n={1} name="So" checked={so} />
        <CheckboxFieldWrapper down disabled={true} n={2} name="Feiertage" checked={feiertage} />
        <CheckboxFieldWrapper down disabled={true} n={2} name="Ferien" checked={ferien} />

        <Grid item xs={12}><Divider /></Grid>

        <Paper className={"uml-paper"}>
            <Table className={"uml-table"}>

                <colspan>
                    <col />
                </colspan>

                <TableHead>
                    <TableRow>

                        <TableCell className={"uml-kursCell"}>Kurs</TableCell>
                        <TableCell>von</TableCell>
                        <TableCell>nach</TableCell>
                        <TableCell className={"uml-slotCell"}>km</TableCell>

                        <TableCell className={"uml-slotCell"}>Start</TableCell>
                        <TableCell className={"uml-slotCell"}>Ende</TableCell>
                        <TableCell className={"uml-slotCell"}>Minuten</TableCell>

                    </TableRow>
                </TableHead>

                <TableBody>
                    {eintraege && eintraege.map((eintrag) => (<TableRow>

                        <TableCell className={"uml-kursCell"}>{eintrag.kurs}</TableCell>
                        <TableCell>{eintrag.von}</TableCell>
                        <TableCell>{eintrag.bis}</TableCell>
                        <TableCell className={"uml-slotCell"}>km</TableCell>

                        <TableCell className={"uml-slotCell"}>{eintrag.start}</TableCell>
                        <TableCell className={"uml-slotCell"}>{eintrag.ende}</TableCell>
                        <TableCell className={"uml-slotCell"}>{eintrag.min}</TableCell>

                    </TableRow>))}
                </TableBody>

            </Table>
        </Paper>

    </Grid>
)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

    componentDidMount = () => {
        console.log("this.props.umlaufplan", this.props.umlaufplanId)
        this.props.doLoad(this.props.umlaufplanId)
    }

    shouldComponentUpdate(props, state) {
        if(props.umlaufplanId !== state.umlaufplanId) {
            this.state.umlaufplanId = props.umlaufplanId
            props.doLoad(props.umlaufplanId)
            return true
        }
        if(props.umlaufplan !== state.umlaufplan) {
            return true
        }
        if(props.dialogOpen !== state.dialogOpen) {
            this.state.dialogOpen = props.dialogOpen
            return true
        }
    }

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

		return (
			<Dialog
                title="Umlaufplan"
                saveAction={this.postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
                noSave
                maxWidth="md"
             >
				<Fields classes={this.props.classes} handleChange={this.handleChange} {...this.props.umlaufplan.data} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doLoad: (id, filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/single/" + id, filter)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/Umlaufplaene/Mini.js